export const DATA_SUFFIX = 'Dadata';
export const ADDRESS_NAME = 'deliveryAddress';
export const ADDRESS_DATA_NAME = `${ADDRESS_NAME}${DATA_SUFFIX}` as const;
export const ADDRESS_CAPTION = 'Выберите адрес или продолжите ввод';
export const ADDRESS_PSEUDO_INPUT_NAME = 'addressPseudoInput';
